import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";

const fmtNum = (v) => {
  if (v == null || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
};

const PrintFeeAbstractReport = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const urlParams = new URLSearchParams(window.location.search);
  const month1 = parseInt(urlParams.get("m1"), 10) || 0;
  const year1 = parseInt(urlParams.get("y1"), 10) || 0;
  const month2 = parseInt(urlParams.get("m2"), 10) || 0;
  const year2 = parseInt(urlParams.get("y2"), 10) || 0;

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState([]);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    document.title = "Print Fee Abstract";

    if (month1 < 1 || year1 < 1 || month2 < 1 || year2 < 1) {
      setLoading(false);
      return;
    }

    axios({
      method: "post",
      url: config.base_url + "MonthlyTask/GetFeeAbstractReport",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID: parseInt(UserID, 10) || 0,
        MemberType: MemberType || "Admin",
        SchoolID: 1,
        SelectedMonth: month1,
        FYear: year1,
        CompareMonth: month2,
        CompareYear: year2,
      },
      timeout: 120000,
    })
      .then((res) => {
        if (res.data?.status_code === 1) {
          setRows(res.data.CompareRows || []);
          setMeta({
            period1Label: res.data.Period1_Label,
            period2Label: res.data.Period2_Label,
            prefix1: res.data.Period1_ChallanPrefix,
            prefix2: res.data.Period2_ChallanPrefix,
            t1Posted: res.data.Period1_TotalFeePosted,
            t2Posted: res.data.Period2_TotalFeePosted,
            t1Arrears: res.data.Period1_TotalArrears,
            t2Arrears: res.data.Period2_TotalArrears,
            t1Concession: res.data.Period1_TotalConcession,
            t2Concession: res.data.Period2_TotalConcession,
            t1Receiveable: res.data.Period1_TotalReceiveable,
            t2Receiveable: res.data.Period2_TotalReceiveable,
          });
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [AccessKey, UserID, MemberType, month1, year1, month2, year2]);

  const title = meta
    ? `Fee Abstract — ${meta.period1Label} vs ${meta.period2Label}`
    : "Fee Abstract";

  const renderRows = () => {
    if (!rows.length) {
      return (
        <tr>
          <td colSpan={12}>
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }

    return rows.map((r, i) => (
      <tr key={`${r.FeeCode}-${i}`}>
        <td>{r.FeeCode}</td>
        <td>{r.Fee_Type_Name || "—"}</td>
        <td className="text-end">{fmtNum(r.Period1_TotalStudent)}</td>
        <td className="text-end">{fmtNum(r.Period1_FeePosted)}</td>
        <td className="text-end">{fmtNum(r.Period1_Arrears)}</td>
        <td className="text-end">{fmtNum(r.Period1_Concession)}</td>
        <td className="text-end">{fmtNum(r.Period1_Receiveable)}</td>
        <td className="text-end">{fmtNum(r.Period2_TotalStudent)}</td>
        <td className="text-end">{fmtNum(r.Period2_FeePosted)}</td>
        <td className="text-end">{fmtNum(r.Period2_Arrears)}</td>
        <td className="text-end">{fmtNum(r.Period2_Concession)}</td>
        <td className="text-end">{fmtNum(r.Period2_Receiveable)}</td>
      </tr>
    ));
  };

  return (
    <Page orientation="landscape" size="legal">
      <table className="table print-main-table">
        <thead>
          <tr>
            <td>
              <PrintHeader title={title} />
              {meta ? (
                <p style={{ fontSize: "10pt", margin: "0 0 8px 0" }}>
                  Challan prefix: <strong>{meta.prefix1}%</strong> ({meta.period1Label}) vs{" "}
                  <strong>{meta.prefix2}%</strong> ({meta.period2Label})
                </p>
              ) : null}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <table className="table table-sm table-bordered table-print">
                <thead>
                  <tr>
                    <th rowSpan={2}>Fee code</th>
                    <th rowSpan={2}>Fee type</th>
                    <th colSpan={5} className="text-center">
                      {meta?.period1Label || "Period 1"}
                    </th>
                    <th colSpan={5} className="text-center">
                      {meta?.period2Label || "Period 2"}
                    </th>
                  </tr>
                  <tr>
                    <th className="text-end">Students</th>
                    <th className="text-end">Fee posted (Rs.)</th>
                    <th className="text-end">Arrears (Rs.)</th>
                    <th className="text-end">Concession (Rs.)</th>
                    <th className="text-end">Receiveable (Rs.)</th>
                    <th className="text-end">Students</th>
                    <th className="text-end">Fee posted (Rs.)</th>
                    <th className="text-end">Arrears (Rs.)</th>
                    <th className="text-end">Concession (Rs.)</th>
                    <th className="text-end">Receiveable (Rs.)</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td className="text-center" colSpan={12}>
                        <Spinner animation="border" role="status" />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {renderRows()}
                      {rows.length > 0 && meta ? (
                        <tr>
                          <th colSpan={2}>Totals</th>
                          <th className="text-end">—</th>
                          <th className="text-end">{fmtNum(meta.t1Posted)}</th>
                          <th className="text-end">{fmtNum(meta.t1Arrears)}</th>
                          <th className="text-end">{fmtNum(meta.t1Concession)}</th>
                          <th className="text-end">{fmtNum(meta.t1Receiveable)}</th>
                          <th className="text-end">—</th>
                          <th className="text-end">{fmtNum(meta.t2Posted)}</th>
                          <th className="text-end">{fmtNum(meta.t2Arrears)}</th>
                          <th className="text-end">{fmtNum(meta.t2Concession)}</th>
                          <th className="text-end">{fmtNum(meta.t2Receiveable)}</th>
                        </tr>
                      ) : null}
                    </>
                  )}
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </Page>
  );
};

export default PrintFeeAbstractReport;
